<template>
    <div class="title-section">
        <h5>A PUBLICATION FROM BROAD INSTITUTE OF MIT AND HARVARD</h5>
        <h5>Last updated {{dateUpdated}}</h5>
        <h1>{{title}}</h1>
    </div>
</template>

<script>
    export default {
        name: 'ArticleHeader',
        props: {
            title: {
                type: String,
                default: 'Hello world!'
            },
            dateUpdated: {
                type: String,
                default: 'Hello world!'
            }
        }
    }
</script>

<style scoped>
 .pub-header-content {
    max-width: 1200px;
    margin: auto
  }
  
  .title-section {
    margin-top: 30px
  }
  
  .title-section h1 {
    margin-top: 40px;
    margin-bottom: 8px;
    
  }
  
  .title-section p {
    margin-bottom: -20px
  }


</style>